import { LocationDto } from "@braoshzmvavz/picnube-common";

export const sortLocations = (locations: LocationDto[]): LocationDto[] => {
  return [...locations].sort((a, b) => {
    // First sort by country
    const countryComparison = a.country.localeCompare(b.country);
    if (countryComparison !== 0) {
      return countryComparison;
    }

    // Then sort by region
    const regionComparison = (a.region || "").localeCompare(b.region || "");
    if (regionComparison !== 0) {
      return regionComparison;
    }

    // Finally sort by name
    return a.name.localeCompare(b.name);
  });
}; 